const STORAGE_KEY_PREFIX = 'box21_last_used_labels';
const MAX_ITEMS = 20;

function storageKey(projectId, labelType) {
  const t = labelType == null || labelType === '' ? 'any' : String(labelType);
  const p = projectId == null || projectId === '' ? '0' : String(projectId);
  return `${STORAGE_KEY_PREFIX}_${p}_${t}`;
}

/**
 * @param {string|null} projectId
 * @param {string|null} labelType box | point | null
 * @returns {Array<{ id: *, name: string, color?: string, type?: string }>}
 */
export function getLastUsedLabels(projectId, labelType) {
  try {
    const raw = localStorage.getItem(storageKey(projectId, labelType));
    if (!raw) {
      return [];
    }
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch (e) {
    return [];
  }
}

/**
 * @param {string|null} projectId
 * @param {string|null} labelType
 * @param {{ id: *, name: string, color?: string, type?: string }} label
 */
export function recordLastUsedLabel(projectId, labelType, label) {
  if (!label || label.id == null || String(label.id).startsWith('__')) {
    return;
  }
  try {
    const key = storageKey(projectId, labelType);
    const row = {
      id: label.id,
      name: label.name,
      color: label.color,
      type: label.type,
    };
    let list = getLastUsedLabels(projectId, labelType);
    list = list.filter((x) => x && x.id !== row.id);
    list.unshift(row);
    list = list.slice(0, MAX_ITEMS);
    localStorage.setItem(key, JSON.stringify(list));
  } catch (e) {
    /* quota or private mode */
  }
}
